<template>
    <div id="Sitemap" class="w3 w90-mb">
        <h1 class="h1 center">網站導覽</h1>
        <div
            class="sitemap-group"
            v-for="(item, index) of navItems"
            :key="'sitemap-group-' + index"
        >
            <h3 class="h2">{{ item.title }}</h3>
            <p
                v-for="subitem of item.items"
                :key="subitem.title"
                class="f18 f16-mb"
            >
                <router-link
                    :to="subitem.routeUrl"
                    tabindex="0"
                    role="button"
                    >{{ subitem.title }}</router-link
                >
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Sitemap',
}
</script>
<script setup>
import getNavItems from '@/data/getNavItems.js'
const { navItems } = getNavItems()
</script>
<style lang="scss" scoped>
#Sitemap {
    margin-bottom: 80px;
}
h3 {
    margin-top: 30px;
}
p {
    padding-top: 10px;
    &::before {
        content: '・';
    }
}
</style>
